class AlgoliaIconRadioUnchecked extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      defaultIconRadioUncheckedUrl: this.getAttribute('default-icon-radio-unchecked-url'),
      iconRadioUncheckedSize: this.getAttribute('icon-radio-unchecked-size'),
      iconRadioUncheckedUrl: this.getAttribute('icon-radio-unchecked-url')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
      .icon-radio-unchecked {
        background-image: url(${this.settings.iconRadioUncheckedUrl ? this.settings.iconRadioUncheckedUrl : this.settings.defaultIconRadioUncheckedUrl});
        background-position: center;
        background-repeat: no-repeat;
        background-size: ${this.settings.iconRadioUncheckedSize}%;
        height: 100%;
        width: 100%;
      }
    `
    style.appendChild(document.createTextNode(css));
    return style;
  }

  /**
   * Renders the icon content.
   * @returns {HTMLElement[]} The rendered icon.
   */
  render() {
    const style = this.getStyle();
    const div = document.createElement('div');
    div.classList.add('icon-radio-unchecked');
    div.setAttribute('aria-hidden', 'true');
    div.focusable = false;
    div.textContent = ' ';
    
    return [style, div];
  }
}

customElements.define("algolia-icon-radio-unchecked", AlgoliaIconRadioUnchecked);